/* =========================================================================
   Mamaie Lenuța — comportamente comune
   Totul e "progressive enhancement": fără JS pagina rămâne lizibilă.
   ========================================================================= */
(function () {
  'use strict';

  var ML = (window.ML = window.ML || {});
  ML.money = function (cents, format) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (format || '{{amount}} lei').replace('{{amount}}', v).replace('{{amount_with_comma_separator}}', v);
  };

  /* Horizon derulează într-un container (.page-wrapper), nu în fereastră.
     Găsim containerul real ca să meargă și bara lipită, și derularea lină. */
  ML.scroller = function () {
    var el = document.querySelector('.page-wrapper');
    if (el && el.scrollHeight > el.clientHeight + 4) {
      var oy = getComputedStyle(el).overflowY;
      if (oy === 'auto' || oy === 'scroll') return el;
    }
    return null;
  };
  ML.onScroll = function (fn) {
    /* „capture" prinde derularea indiferent cine derulează: fereastra sau un container */
    document.addEventListener('scroll', fn, { capture: true, passive: true });
    window.addEventListener('resize', fn, { passive: true });
  };
  ML.scrollToEl = function (el) {
    if (!el) return;
    try {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {
      el.scrollIntoView();
    }
  };

  /* ----------------------------------------------------- apariție la scroll */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.ml-reveal:not([data-ml-seen])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { el.setAttribute('data-ml-seen', '1'); io.observe(el); });
  }

  /* ------------------------------------------------------- bara anunțuri */
  function initAnnounce(root) {
    (root || document).querySelectorAll('[data-ml-announce]:not([data-ml-on])').forEach(function (bar) {
      bar.setAttribute('data-ml-on', '1');
      var items = bar.querySelectorAll('.ml-announce__item');
      if (items.length < 2) return;
      var delay = parseInt(bar.getAttribute('data-ml-announce'), 10) || 4500;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, delay);
    });
  }

  /* ------------------------------------------------------------ meniu mobil */
  function initDrawer(root) {
    (root || document).querySelectorAll('[data-ml-drawer]:not([data-ml-on])').forEach(function (drawer) {
      drawer.setAttribute('data-ml-on', '1');
      var id = drawer.getAttribute('data-ml-drawer');
      function close() {
        drawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
      document.querySelectorAll('[data-ml-drawer-open="' + id + '"]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          drawer.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
          var first = drawer.querySelector('[data-ml-drawer-close]');
          if (first) first.focus();
        });
      });
      drawer.querySelectorAll('[data-ml-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); close(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    });
  }

  /* ------------------------------------------------------------ cronometru */
  function initTimer(root) {
    (root || document).querySelectorAll('[data-ml-timer]:not([data-ml-on])').forEach(function (el) {
      el.setAttribute('data-ml-on', '1');
      var minutes = parseInt(el.getAttribute('data-ml-timer'), 10) || 30;
      var key = 'ml_timer_' + (el.getAttribute('data-ml-timer-key') || 'default');
      var end;
      try { end = parseInt(sessionStorage.getItem(key), 10); } catch (err) { end = null; }
      if (!end || isNaN(end) || end < Date.now()) {
        end = Date.now() + minutes * 60000;
        try { sessionStorage.setItem(key, String(end)); } catch (err) {}
      }
      var out = el.querySelector('.ml-timer__clock') || el;
      function tick() {
        var left = Math.max(0, end - Date.now());
        var t = Math.floor(left / 1000);
        var h = Math.floor(t / 3600);
        var m = Math.floor((t % 3600) / 60);
        var s = t % 60;
        var pad = function (n) { return n < 10 ? '0' + n : String(n); };
        out.textContent = (h > 0 ? pad(h) + ':' : '') + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* -------------------------------------------------------- comutator tab */
  function initSwitch(root) {
    (root || document).querySelectorAll('[data-ml-switch]:not([data-ml-on])').forEach(function (wrap) {
      wrap.setAttribute('data-ml-on', '1');
      var btns = wrap.querySelectorAll('[data-ml-switch-btn]');
      var panes = wrap.querySelectorAll('[data-ml-switch-pane]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-ml-switch-btn');
          btns.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panes.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-ml-switch-pane') === target);
          });
        });
      });
    });
  }

  /* -------------------------------------------------------------- galerie */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-ml-gallery]:not([data-ml-on])').forEach(function (g) {
      g.setAttribute('data-ml-on', '1');
      var slides = g.querySelectorAll('.ml-gallery__slide');
      var thumbs = g.querySelectorAll('.ml-gallery__thumb');
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
          thumbs.forEach(function (x, j) { x.classList.toggle('is-active', i === j); });
        });
      });
    });
  }

  /* ------------------------------------------------------ selector ofertă */
  function initOffers(root) {
    (root || document).querySelectorAll('[data-ml-offers]:not([data-ml-on])').forEach(function (wrap) {
      wrap.setAttribute('data-ml-on', '1');
      var opts = wrap.querySelectorAll('.ml-offer');
      function sync(chosen) {
        opts.forEach(function (o) {
          var input = o.querySelector('input');
          var on = o === chosen;
          o.classList.toggle('is-active', on);
          if (input) input.checked = on;
        });
        var scope = wrap.closest('[data-ml-buy]') || document;
        var ev = new CustomEvent('ml:offer', {
          bubbles: true,
          detail: {
            variant: chosen.getAttribute('data-variant'),
            qty: parseInt(chosen.getAttribute('data-qty'), 10) || 1,
            price: parseInt(chosen.getAttribute('data-price'), 10) || 0,
            label: chosen.getAttribute('data-label') || '',
            needsShipping: chosen.getAttribute('data-ship') !== 'false'
          }
        });
        scope.dispatchEvent(ev);
      }
      opts.forEach(function (o) {
        o.addEventListener('click', function () { sync(o); });
        o.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); sync(o); }
        });
      });
      var active = wrap.querySelector('.ml-offer.is-active') || opts[0];
      if (active) sync(active);
    });
  }

  /* ---------------------------------------------------------- bară sticky */
  function initSticky(root) {
    (root || document).querySelectorAll('[data-ml-sticky]:not([data-ml-on])').forEach(function (bar) {
      bar.setAttribute('data-ml-on', '1');
      var afterSel = bar.getAttribute('data-ml-sticky');
      var anchor = afterSel ? document.querySelector(afterSel) : null;

      function update() {
        var show;
        if (anchor) {
          show = anchor.getBoundingClientRect().bottom < 0;
        } else {
          var scroller = ML.scroller();
          show = (scroller ? scroller.scrollTop : window.scrollY) > 600;
        }
        bar.classList.toggle('is-visible', show);
      }
      update();
      ML.onScroll(update);
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(update, { threshold: [0, 1] }).observe(anchor);
      }
    });
  }

  /* ---------------------------------------------------------------- quiz */
  function initQuiz(root) {
    (root || document).querySelectorAll('[data-ml-quiz]:not([data-ml-on])').forEach(function (quiz) {
      quiz.setAttribute('data-ml-on', '1');
      var steps = Array.prototype.slice.call(quiz.querySelectorAll('.ml-quiz__step'));
      var result = quiz.querySelector('.ml-quiz__result');
      var fill = quiz.querySelector('.ml-quiz__fill');
      var scores = {};
      var idx = 0;

      function show(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        if (fill) fill.style.width = Math.round(((i + 1) / (steps.length + 1)) * 100) + '%';
      }
      function finish() {
        steps.forEach(function (s) { s.classList.remove('is-active'); });
        if (fill) fill.style.width = '100%';
        var best = null;
        Object.keys(scores).forEach(function (k) {
          if (!best || scores[k] > scores[best]) best = k;
        });
        var cards = quiz.querySelectorAll('[data-ml-quiz-result]');
        var shown = false;
        cards.forEach(function (c) {
          var on = c.getAttribute('data-ml-quiz-result') === best;
          c.hidden = !on;
          if (on) shown = true;
        });
        if (!shown && cards.length) cards[0].hidden = false;
        if (result) result.classList.add('is-active');
        ML.scrollToEl(quiz);
      }

      quiz.querySelectorAll('.ml-quiz__opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-value') || '';
          val.split(',').forEach(function (v) {
            v = v.trim();
            if (v) scores[v] = (scores[v] || 0) + 1;
          });
          idx++;
          if (idx >= steps.length) finish();
          else show(idx);
        });
      });
      quiz.querySelectorAll('.ml-quiz__back').forEach(function (b) {
        b.addEventListener('click', function () {
          if (idx > 0) { idx--; show(idx); }
        });
      });
      show(0);
    });
  }

  /* -------------------------------------------------- adăugare în coș/plată */
  ML.addToCart = function (items, attributes) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Eroare la adăugarea în coș.');
          return data;
        });
      })
      .then(function (data) {
        if (!attributes || !Object.keys(attributes).length) return data;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function () { return data; });
      });
  };

  ML.goToCheckout = function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.assign(root + 'checkout');
  };

  /* buton simplu „cumpără acum" */
  function initBuy(root) {
    (root || document).querySelectorAll('[data-ml-buy-btn]:not([data-ml-on])').forEach(function (btn) {
      btn.setAttribute('data-ml-on', '1');
      var scope = btn.closest('[data-ml-buy]') || document;
      var state = {
        variant: btn.getAttribute('data-variant'),
        qty: parseInt(btn.getAttribute('data-qty'), 10) || 1
      };
      scope.addEventListener('ml:offer', function (e) {
        if (e.detail.variant) state.variant = e.detail.variant;
        state.qty = e.detail.qty || 1;
      });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!state.variant) return;
        btn.classList.add('is-loading');
        var mode = btn.getAttribute('data-mode') || 'checkout';
        ML.addToCart([{ id: Number(state.variant), quantity: state.qty }])
          .then(function () {
            if (mode === 'cart') window.location.assign('/cart');
            else ML.goToCheckout();
          })
          .catch(function (err) {
            btn.classList.remove('is-loading');
            window.alert(err.message || 'A apărut o eroare. Încearcă din nou.');
          });
      });
    });
  }

  /* ------------------------------------------------ formular plata ramburs */
  function initCod(root) {
    (root || document).querySelectorAll('[data-ml-cod]:not([data-ml-on])').forEach(function (form) {
      form.setAttribute('data-ml-on', '1');
      var scope = form.closest('[data-ml-buy]') || form;
      var msg = form.querySelector('[data-ml-cod-msg]');
      var btn = form.querySelector('[data-ml-cod-submit]');
      var mode = form.getAttribute('data-mode') || 'checkout';
      var endpoint = form.getAttribute('data-endpoint') || '';
      var prefill = form.getAttribute('data-prefill') === 'true';
      var state = {
        variant: form.getAttribute('data-variant'),
        qty: parseInt(form.getAttribute('data-qty'), 10) || 1,
        price: parseInt(form.getAttribute('data-price'), 10) || 0,
        label: '',
        needsShipping: form.getAttribute('data-ship') !== 'false'
      };
      var emailInput = form.querySelector('[name="Email"]');
      var emailWasRequired = emailInput ? emailInput.hasAttribute('data-required') : false;

      scope.addEventListener('ml:offer', function (e) {
        if (e.detail.variant) state.variant = e.detail.variant;
        state.qty = e.detail.qty || 1;
        state.price = e.detail.price || state.price;
        state.label = e.detail.label || '';
        if (typeof e.detail.needsShipping === 'boolean') state.needsShipping = e.detail.needsShipping;
        syncSummary();
      });

      function syncSummary() {
        var fmt = form.getAttribute('data-money') || '{{amount}} lei';
        var ship = parseInt(form.getAttribute('data-shipping'), 10) || 0;
        var free = parseInt(form.getAttribute('data-free-over'), 10) || 0;
        var shipNow = ship;
        if (!state.needsShipping) shipNow = 0;
        else if (free && state.price >= free) shipNow = 0;
        /* pentru cărțile digitale avem nevoie de e-mail ca să le putem trimite */
        if (emailInput) {
          var must = emailWasRequired || !state.needsShipping;
          if (must) emailInput.setAttribute('data-required', '');
          else emailInput.removeAttribute('data-required');
          var star = form.querySelector('[data-ml-email-star]');
          if (star) star.hidden = !must;
        }
        var set = function (sel, val) {
          var el = form.querySelector(sel);
          if (el) el.textContent = val;
        };
        set('[data-ml-sum-label]', state.label || form.getAttribute('data-label') || '');
        set('[data-ml-sum-product]', ML.money(state.price, fmt));
        set('[data-ml-sum-ship]', shipNow === 0 ? 'GRATUIT' : ML.money(shipNow, fmt));
        set('[data-ml-sum-total]', ML.money(state.price + shipNow, fmt));
      }
      syncSummary();

      function fieldError(input, on, text) {
        var wrap = input.closest('.ml-field') || input.parentNode;
        wrap.classList.toggle('has-error', on);
        input.setAttribute('aria-invalid', on ? 'true' : 'false');
        if (on && text) {
          var e = wrap.querySelector('.ml-field__error');
          if (e) e.textContent = text;
        }
      }

      function validate() {
        var ok = true;
        form.querySelectorAll('[data-required]').forEach(function (input) {
          var val = (input.value || '').trim();
          var bad = !val;
          if (!bad && input.getAttribute('data-validate') === 'phone') {
            bad = !/^(\+?4?0)?[0-9 .\-()]{9,15}$/.test(val) || val.replace(/\D/g, '').length < 10;
          }
          if (!bad && input.getAttribute('data-validate') === 'email') {
            bad = !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val);
          }
          if (!bad && input.getAttribute('data-validate') === 'name') {
            bad = val.length < 3 || val.indexOf(' ') === -1;
          }
          fieldError(input, bad, input.getAttribute('data-error') || 'Te rugăm completează acest câmp.');
          if (bad && ok) { ok = false; try { input.focus(); } catch (e) {} }
        });
        return ok;
      }

      form.querySelectorAll('[data-required]').forEach(function (input) {
        input.addEventListener('blur', function () {
          if ((input.value || '').trim()) fieldError(input, false);
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (msg) msg.className = 'ml-cod__msg';
        if (!validate()) {
          if (msg) { msg.className = 'ml-cod__msg is-error'; msg.textContent = 'Mai sunt câmpuri de completat.'; }
          return;
        }
        if (!state.variant) {
          if (msg) { msg.className = 'ml-cod__msg is-error'; msg.textContent = 'Produsul nu este disponibil momentan.'; }
          return;
        }
        var data = {};
        form.querySelectorAll('[name]').forEach(function (input) {
          if (input.type === 'checkbox') data[input.name] = input.checked ? 'Da' : 'Nu';
          else if (input.value) data[input.name] = input.value.trim();
        });

        if (btn) btn.classList.add('is-loading');

        /* modul „endpoint": comanda se creează pe serverul propriu */
        if (mode === 'endpoint' && endpoint) {
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              variant_id: state.variant,
              quantity: state.qty,
              offer: state.label,
              customer: data,
              page: window.location.href
            })
          })
            .then(function (r) { return r.json().catch(function () { return {}; }); })
            .then(function (out) {
              if (out && out.ok) {
                form.reset();
                if (msg) { msg.className = 'ml-cod__msg is-ok'; msg.textContent = form.getAttribute('data-ok') || 'Comanda a fost înregistrată. Te sunăm pentru confirmare.'; }
                if (out.redirect) window.location.assign(out.redirect);
              } else {
                throw new Error((out && out.error) || 'Comanda nu a putut fi trimisă.');
              }
            })
            .catch(function (err) {
              if (msg) { msg.className = 'ml-cod__msg is-error'; msg.textContent = err.message; }
            })
            .then(function () { if (btn) btn.classList.remove('is-loading'); });
          return;
        }

        /* modul implicit: coș + checkout Shopify, cu datele păstrate pe comandă */
        var props = {};
        Object.keys(data).forEach(function (k) { if (k.charAt(0) !== '_') props[k] = data[k]; });
        ML.addToCart([{ id: Number(state.variant), quantity: state.qty, properties: props }], props)
          .then(function () {
            if (!prefill) return ML.goToCheckout();
            var root2 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            var name = (data['Nume și prenume'] || '').split(' ');
            var q = [];
            var add = function (k, v) { if (v) q.push(k + '=' + encodeURIComponent(v)); };
            add('checkout[shipping_address][first_name]', name[0] || '');
            add('checkout[shipping_address][last_name]', name.slice(1).join(' '));
            add('checkout[shipping_address][address1]', data['Adresa'] || '');
            add('checkout[shipping_address][city]', data['Localitate'] || '');
            add('checkout[shipping_address][province]', data['Județ'] || '');
            add('checkout[shipping_address][country]', 'Romania');
            add('checkout[shipping_address][phone]', data['Telefon'] || '');
            add('checkout[email]', data['Email'] || '');
            window.location.assign(root2 + 'checkout' + (q.length ? '?' + q.join('&') : ''));
          })
          .catch(function (err) {
            if (btn) btn.classList.remove('is-loading');
            if (msg) { msg.className = 'ml-cod__msg is-error'; msg.textContent = err.message || 'A apărut o eroare. Încearcă din nou.'; }
          });
      });
    });
  }

  /* ------------------------------------------------------- „arată mai mult" */
  function initMore(root) {
    (root || document).querySelectorAll('[data-ml-more]:not([data-ml-on])').forEach(function (btn) {
      btn.setAttribute('data-ml-on', '1');
      btn.addEventListener('click', function () {
        var target = document.querySelector(btn.getAttribute('data-ml-more'));
        if (!target) return;
        target.querySelectorAll('[hidden]').forEach(function (el) { el.hidden = false; });
        btn.remove();
      });
    });
  }

  /* --------------------------------------------------------- scroll lin */
  function initAnchors(root) {
    (root || document).querySelectorAll('[data-ml-scroll]:not([data-ml-on])').forEach(function (a) {
      a.setAttribute('data-ml-on', '1');
      a.addEventListener('click', function (e) {
        var sel = a.getAttribute('data-ml-scroll');
        var target = document.querySelector(sel);
        if (!target) return;
        e.preventDefault();
        ML.scrollToEl(target);
        var focusable = target.querySelector('input, select, textarea');
        if (focusable) setTimeout(function () { try { focusable.focus({ preventScroll: true }); } catch (err) {} }, 500);
      });
    });
  }

  /* footerul: pliat pe telefon, desfasurat pe desktop */
  function initFooterCols(root) {
    var cols = (root || document).querySelectorAll('[data-ml-footer-col]:not([data-ml-on])');
    if (!cols.length) return;
    cols.forEach(function (c) { c.setAttribute('data-ml-on', '1'); });
    var mq = window.matchMedia('(min-width: 750px)');
    function apply() {
      document.querySelectorAll('[data-ml-footer-col]').forEach(function (c) {
        c.open = mq.matches;
      });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function boot(root) {
    initReveal(root);
    initFooterCols(root);
    initAnnounce(root);
    initDrawer(root);
    initTimer(root);
    initSwitch(root);
    initGallery(root);
    initOffers(root);
    initSticky(root);
    initQuiz(root);
    initBuy(root);
    initCod(root);
    initMore(root);
    initAnchors(root);
  }

  ML.boot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* re-inițializare în editorul de teme */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
